import PageLoadedQueue from "../PageLoadedQueue";

class PasswordStrength {

    protected element:HTMLElement;

    constructor(element: HTMLElement) {
        this.element = element;
        this.initialize();
    }

    protected scorePassword(password: string): number {
        let score = 0;
        if (!password) return score;

        score += password.length * 4;

        const variations: Record<string, boolean> = {
            digits: /\d/.test(password),
            lower: /[a-z]/.test(password),
            upper: /[A-Z]/.test(password),
            nonWords: /\W/.test(password),
        };

        const variationCount = Object.values(variations).filter(Boolean).length;
        score += (variationCount - 1) * 10;

        return Math.min(score, 100);
    }

    protected initialize() {

        this.element.addEventListener('keyup', (event: KeyboardEvent) => {
            const inputElement = event.target as HTMLInputElement;
            const value = inputElement.value;
            const score = this.scorePassword(value);
            const indicator = document.querySelector<HTMLElement>('.password-strength-indicator');
            const indicatorSteps = Array.from(indicator?.querySelectorAll('span') || []).slice(0, 3);
            const indicatorText = indicator?.querySelector<HTMLElement>('.strength-text');

            if (!indicator || !indicatorText) return;

            indicatorSteps.forEach(step => {
                step.classList.remove('invalid', 'weak', 'good', 'strong');
            });

            if (value === '') {
                indicatorText.innerHTML = '';
                return;
            }

            if (score > 80) {
                indicatorSteps.forEach(step => step.classList.add('strong'));
                indicatorText.innerHTML = indicator.dataset.strong || '';
                return;
            }

            if (score > 60) {
                indicatorSteps.slice(0, 2).forEach(step => step.classList.add('good'));
                indicatorText.innerHTML = indicator.dataset.good || '';
                return;
            }

            if (score <= 60) {
                if (value.length < 12) {
                    indicatorSteps.slice(0, 1).forEach(step => step.classList.add('invalid'));
                    indicatorText.innerHTML = indicator.dataset.invalid || '';
                } else {
                    indicatorSteps.slice(0, 1).forEach(step => step.classList.add('weak'));
                    indicatorText.innerHTML = indicator.dataset.weak || '';
                }
            }
        });
    }

    static initializedElements:Map<HTMLElement, PasswordStrength> = new Map();

    static initialize() {
        PasswordStrength.checkElements();
        document.addEventListener('plandent.html.changed', (e) => {
            PasswordStrength.checkElements();
        });
    }
    static checkElements() {
        document.querySelectorAll('.password-strength').forEach((element: HTMLElement) => {
            if(!PasswordStrength.initializedElements.has(element)) {
                PasswordStrength.initializedElements.set(element, new PasswordStrength(element));
            }
        });
    }
}

PageLoadedQueue.addFunction(PasswordStrength.initialize);
